import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import ImpactStories from './components/ImpactStories';
import DonateSection from './components/DonateSection';
import VolunteerSection from './components/VolunteerSection';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import ContactSection from './components/ContactSection';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <ImpactStories />
      <DonateSection />
      <VolunteerSection />
      <AboutSection />
      <TestimonialSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
